// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1p-e";
export var animationRelative = "_1p-d";
export var backdropBlur = "_1p-0";
export var detailLabelCell = "_1p-q";
export var detailTable = "_1p-p";
export var detailValueCell = "_1p-r";
export var documentTypeIcon = "_1p-y";
export var documentTypeOption = "_1p-x";
export var dropdownMatchDatePicker = "_1p-3";
export var evidenceCardContent = "_1p-w";
export var gorgiasTicketCard = "_1p-s";
export var iconTertiary = "_1p-z";
export var integrationCard = "_1p-1";
export var integrationLogoBox = "_1p-2";
export var mainColumnSticky = "_1p-v";
export var maxWidthContainer = "_1p-t";
export var modalContentBody = "_1p-a";
export var modalHeaderImage = "_1p-5";
export var modalImageLabel = "_1p-7";
export var modalImageOverlay = "_1p-6";
export var modalImageSubtitle = "_1p-9";
export var modalImageTitle = "_1p-8";
export var modalImageWrapper = "_1p-4";
export var modalStickyFooter = "_1p-b";
export var sidebarColumn = "_1p-u";
export var timelineLine = "_1p-m";
export var timelineLineBlack = "_1p-o _1p-m";
export var timelineLineGray = "_1p-n _1p-m";
export var timelineLineHeight = "_1p-l";
export var tlDotActivate = "_1p-i";
export var tlDotActivateAnim = "_1p-h";
export var tlDotHide = "_1p-g";
export var tlDotHideAnim = "_1p-f";
export var tlLineActivate = "_1p-k";
export var tlLineActivateAnim = "_1p-j";
export var uploadedFileRow = "_1p-c";